import React, { useEffect, useState } from 'react';
import { Route, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { BrandPageContainer } from 'components/BrandPage/BrandPageComponent';
import { NotFound } from 'components/NotFound/Container/NotFound';
import { getCmsClient } from 'common/utilities/cmsClient';
import { getNavigationLinkContent } from '@kfc-global/react-shared/redux/Actions/ContentAction';
import isEmpty from 'lodash/isEmpty';
import { BrandPageConstant } from 'common/constants/SharedConstants';
import { StructureData } from '../../../organisms/StructureDataComponent';

export const getBrandPageRoute = (rest, routePath, brandPageContent) => {
  if (!isEmpty(brandPageContent?.fields?.[0]?.body)) {
    const { sd: seoTemplate = {}, body: brandPageData = [] } = brandPageContent.fields[0] ?? {};
    return (
      <Route
        {...rest}
        render={props => {
          return (
            <>
              {seoTemplate && <StructureData seoTemplate={seoTemplate} />}
              <BrandPageContainer routePath={routePath} {...props} pageData={brandPageData} />
            </>
          );
        }}
      />
    );
  }
  return null;
};

const BrandPageRoute = ({ ...rest }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [brandPageRoute, setBrandPageRoute] = useState(null);

  const { BRAND_PAGE } = BrandPageConstant;

  const navigationLinkContent =
    useSelector(
      ({
        contentReducer: { navigationLinkResponse: { fields } = [], isContentfulLoading: isLoading = true } = {},
      }) => ({
        fields,
        isLoading,
      }),
    ) ?? {};
  const [isBrandPageLoading, setIsBrandPageLoading] = useState(true);
  const [brandPageContentDataStr, setBrandPageContentDataStr] = useState();
  const fieldsData = JSON.stringify(navigationLinkContent?.fields);
  useEffect(() => {
    if (!navigationLinkContent?.isLoading) {
      setIsBrandPageLoading(navigationLinkContent?.isLoading);
      setBrandPageContentDataStr(fieldsData);
    }
  }, [navigationLinkContent?.isLoading, fieldsData]);

  useEffect(() => {
    dispatch(
      getNavigationLinkContent({
        cmsClient: getCmsClient(),
        query: {
          content_type: BRAND_PAGE,
          'fields.url': location?.pathname,
          include: '5',
        },
      }),
    );
  }, [BRAND_PAGE, dispatch, location?.pathname]);

  useEffect(() => {
    if (!isBrandPageLoading && !navigationLinkContent?.isLoading) {
      const brandRoute = getBrandPageRoute(rest, location?.pathname, navigationLinkContent);
      setBrandPageRoute(brandRoute);
      setIsBrandPageLoading(isBrandPageLoading);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandPageContentDataStr, isBrandPageLoading, location, navigationLinkContent?.isLoading]);

  if (isBrandPageLoading) {
    return null;
  }
  if (brandPageRoute) {
    return <>{brandPageRoute}</>;
  }

  if (navigationLinkContent?.fields && !navigationLinkContent?.fields?.length) {
    return <Route component={NotFound} />;
  } else {
    return null;
  }
};

export default BrandPageRoute;
